module.exports = __webpack_public_path__ + "img/Dormant volcano - Village of Harz.a241074c.webp";